var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteMailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 10.5,
    viewBox: "0 0 14 10.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1.313-10.5H-12.688A1.313,1.313,0,0,0-14-9.187v7.875A1.313,1.313,0,0,0-12.688,0H-1.313A1.313,1.313,0,0,0,0-1.312V-9.187A1.313,1.313,0,0,0-1.313-10.5Zm-11.375.875H-1.313a.439.439,0,0,1,.437.437v1.132c-.6.506-1.455,1.2-4.118,3.317C-5.455-4.372-6.366-3.489-7-3.5c-.634.011-1.548-.872-2.007-1.239-2.663-2.114-3.519-2.811-4.118-3.317V-9.187A.439.439,0,0,1-12.688-9.625ZM-1.313-.875H-12.688a.439.439,0,0,1-.437-.437V-6.918c.623.511,1.608,1.3,3.574,2.863C-8.991-3.607-8-2.62-7-2.625s1.977-.971,2.551-1.43C-2.483-5.616-1.5-6.407-.875-6.918v5.605A.439.439,0,0,1-1.313-.875Z",
    transform: "translate(14 10.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteMailIcon);
export default __webpack_public_path__ + "static/media/white-mail-icon.8709f24b2e22bc73fd7cef2660a084b9.svg";
export { ForwardRef as ReactComponent };